import Reflux from "reflux";
import Store from "logic/local-storage/Store";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import { Builder } from "logic/rest/FetchProvider";
import { singletonStore, singletonActions } from "logic/singleton";
export const SessionActions = singletonActions(
  "core.Session",
  () => Reflux.createActions({
    login: { asyncResult: true },
    logout: { asyncResult: true },
    validate: { asyncResult: true }
  })
);
export const SessionStore = singletonStore(
  "core.Session",
  () => Reflux.createStore({
    listenables: [SessionActions],
    sourceUrl: "/system/sessions",
    username: void 0,
    validatingSession: false,
    init() {
      this.validate();
    },
    getInitialState() {
      return this.getSessionInfo();
    },
    login(username, password, host) {
      const builder = new Builder("POST", qualifyUrl(this.sourceUrl)).json({ username, password, host });
      const promise = builder.build().then((response) => ({ username: response == null ? void 0 : response.username }));
      SessionActions.login.promise(promise);
    },
    logout() {
      const promise = new Builder("DELETE", qualifyUrl(`${this.sourceUrl}/`)).build().then((resp) => {
        if (resp.ok || resp.status === 401) {
          this._removeSession();
        }
      }, this._removeSession);
      SessionActions.logout.promise(promise);
    },
    validate() {
      const username = Store.get("username");
      this.validatingSession = true;
      this._propagateState();
      const promise = this._validateSession().then((response) => {
        var _a;
        if (response.is_valid) {
          return SessionActions.login.completed({
            username: (_a = response.username) != null ? _a : username
          });
        }
        if (username) {
          this._removeSession();
        }
        return response;
      }).finally(() => {
        this.validatingSession = false;
        this._propagateState();
      });
      SessionActions.validate.promise(promise);
    },
    _validateSession() {
      return new Builder("GET", qualifyUrl(ApiRoutes.SessionsApiController.validate().url)).json().build();
    },
    _removeSession() {
      Store.delete("username");
      this.username = void 0;
      this._propagateState();
    },
    _propagateState() {
      this.trigger(this.getSessionInfo());
    },
    loginCompleted(sessionInfo) {
      const { username } = sessionInfo;
      Store.set("username", username);
      this.username = username;
      this._propagateState();
    },
    isLoggedIn() {
      return !!this.username;
    },
    getSessionInfo() {
      return { username: this.username, validatingSession: this.validatingSession };
    }
  })
);
